import DynamicMessage from '../components/DynamicMessage';

const DYNAMIC_MESSAGE_SETTINGS = {
  title: 'Welcome Dynamic Message',
  className: '',
  inputs: [
    {
      label: 'Dynamic Message',
      key: 'dynamicMessage',
      component: DynamicMessage,
    },
  ],
};

export default DYNAMIC_MESSAGE_SETTINGS;
